import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

import { JobType, RepositoryModal } from '../../shared'

@Component({
    templateUrl: './job-type.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent],
})
export class JobTypeComponent extends RepositoryModal<JobType> {}
